import React from 'react';

import useQuery from 'hooks/useQuery';
import services from 'services/services';
import { Select } from '@rebass/forms';
import { Skeleton } from 'components/Skeleton';

/**
 * Select with populated brandings.
 *
 * @param {React.InputHTMLAttributes} props
 */
export function BrandingSelect(props) {
    const {
        /**
         * @type {import('/services/services').Branding[]} brandings
         */
        data: brandings,
        isLoading
    } = useQuery({
        queryFn: () => services.getBrandings()
    });

    if (isLoading) return <Skeleton height={32} width="100%" />;

    return (
        <Select {...props}>
            <option value="">None</option>
            {brandings.map(branding => (
                <option key={branding.id} value={branding.id}>
                    {branding.name}
                </option>
            ))}
        </Select>
    );
}
